import { render, staticRenderFns } from "./Lgx296721465602998272.vue?vue&type=template&id=fff86f84&scoped=true&"
import script from "./Lgx296721465602998272.vue?vue&type=script&lang=js&"
export * from "./Lgx296721465602998272.vue?vue&type=script&lang=js&"
import style0 from "./Lgx296721465602998272.vue?vue&type=style&index=0&id=fff86f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff86f84",
  null
  
)

export default component.exports